// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import PublishBoardPanel from '../popup/publish/PublishBoardPanel';
import BoardEditorPanel from '../popup/editing/BoardEditorPanel';

const ShareModalContent = (props) => (
    <div className="ShareModalContent">
        <BoardEditorPanel {...props} />
        <PublishBoardPanel {...props} />
    </div>
);

ShareModalContent.propTypes = {
    mode: PropTypes.string,
};

export default ShareModalContent;
